import { useEffect } from "react";
import { useSelector } from "react-redux";
import { miscSlice } from "redux/slices/miscSlice";
import { getDispatch } from "app/StoreFactory";

// sets a value (object, array) in redux store, returns state selector
export const useSet = (key, value, deps) => {
  const ret = useSelector((state) => state.misc[key]);

  useEffect(() => {
    const dispatch = getDispatch();
    dispatch(miscSlice.actions.set({ key, value }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return ret;
};
